import React from 'react';
import styled from 'styled-components';
import { H1, P, Bold } from '../../../components/Typography/Typography';

export const SectionCrazy = function() {
  return (
    <Container>
      <TextBox>
        <H1>
          Wanna know <U>the crazy part?</U>
        </H1>
        <PText>
          External forces may have pushed your church to embrace digital in new ways in recent months, but these
          opportunities have <Bold>always</Bold> existed.
        </PText>
        <PText>
          And they will <Bold>continue</Bold> to exist for many years to come.
        </PText>
        <PText>
          <U>Most importantly?</U>
        </PText>
        <PText>
          It’s shortsighted to think things will just <em>go back to how they were before.</em>
        </PText>
        <PText>
          No. It’s time to prepare for <Bold>a new normal</Bold>.
        </PText>
        <PText>Here’s how...</PText>
      </TextBox>
    </Container>
  );
};

const Container = styled.section`
  margin: 0;
  position: relative;
  width: 100vw;
`;

const TextBox = styled.div`
  z-index: 2;
  position: relative;

  max-width: 65rem;
  margin-left: auto;
  margin-right: auto;

  padding: 4rem 3rem 0;
`;

const PText = styled(P)`
  max-width: 50rem;
`;

const U = styled.span`
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionCrazy.js